import { render } from "./iLoveYou.vue?vue&type=template&id=799752d0&ts=true"
import script from "./iLoveYou.vue?vue&type=script&lang=ts"
export * from "./iLoveYou.vue?vue&type=script&lang=ts"

import "./iLoveYou.vue?vue&type=style&index=0&id=799752d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__